import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
import axios from 'axios'

export default {
  createTimer (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/start', body)
  },
  pauseTimer (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/pause', body)
  },
  completeTimer (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/complete', body)
  },
  createSubTimer (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/subTimer', body)
  },
  createManualTimer (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/createManual', body)
  },
  createCommentTimer (body, subTimerId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post(`timer/createComment/${subTimerId}`, body)
  },
  deleteTimer (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.delete(`timer/deleteSubTimer/${id}`)
  },
  getActiveTimer (userId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`timer/getActiveTimer/${userId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Timer/api.js